export const NBN_SESSION_KEYS = {
  NBN_PROMO: 'nbnPromo',
  NBN_ORDER: 'nbnOrder',
  PRODUCTS: 'nbnProducts',
  RESUME_ORDER_CONTEXT: 'nbnOrderResumeContext',
  SQ_DONE: 'sqDone',
  SQ_FLOW: 'sqFlow',
  SQ_MODEL: 'sqModel',
  SQ_REFERRAL: 'sqReferral',
  SQ_STEPS: 'step-address-lookup',
  STORE: 'nbnStore'
} as const;

export const NBN_PERSISTENT_STORE_KEYS = {
  NBN_PERSISTED_ORDER: 'nbnPersistedOrder'
} as const;

// Expire span for NBN persisted data in milliseconds (7 days)
export const NBN_PERSISTENT_EXPIRE_SPAN = 7 * 24 * 60 * 60 * 1000;

export const AGENT_SESSION_KEYS = {
  NOTIFICATION_CHANNEL: 'notificationChannel',
  ORDER_ID: 'orderId'
} as const;

export const LAST_SELECTED_KEYS = {
  SELECTED_PLAN_CODE: 'lastSelectedPlanCode'
} as const;

export const SESSION_KEYS = {
  ...NBN_SESSION_KEYS,
  ...AGENT_SESSION_KEYS,
  ...LAST_SELECTED_KEYS,
  USER_SESSION: 'userSession'
} as const;
